import React, { useEffect, useRef } from "react";
import { rollerInfo } from "../../constants/rollet";

const RouletteWheel = ({ speed, draw, position, doc }) => {

    const result = draw?.lastResult?.result ?? 0;
    const angleRef = useRef(0);
    const animationFrameRef = useRef(null);

    const roulette5Ref = useRef(null);
    const roulette2Ref = useRef(null);
    const rouletteShadowRef = useRef(null);
    const ballSpinRef = useRef(null);
    const ballRef = useRef(null);

    useEffect(() => {
        if (!ballRef.current || !ballSpinRef.current) return;

        doc.current = {
            ...(doc.current || {}),
            ball: ballRef.current,
            ballSpin: ballSpinRef.current,
        };

        const wheelPosition = result ? rollerInfo[result] : 0;

        position.current = wheelPosition;
        ballSpinRef.current.style.transform = `rotate(${wheelPosition}deg)`;

        if (!result) {
            ballRef.current.style.display = "none";
        } else {
            ballRef.current.style.animation = "none";
            ballRef.current.style.bottom = "-13.2%";
            ballRef.current.style.display = "block";
        }
    }, [result, position, doc]);

    useEffect(() => {
        const roulette5 = roulette5Ref.current;
        const roulette2 = roulette2Ref.current;
        const rouletteShadow = rouletteShadowRef.current;
        const ball = ballRef.current;

        if (!roulette5 || !roulette2 || !rouletteShadow || !ball) return;

        const rotate = () => {
            angleRef.current += speed.current;

            if (angleRef.current > 360 || angleRef.current < 0) {
                angleRef.current = 0;
            }

            roulette5.style.transform = `rotateX(-45.2deg) rotate(${-angleRef.current}deg)`;
            roulette2.style.transform = `rotateX(45deg) rotate(${-angleRef.current}deg)`;
            rouletteShadow.style.transform = `rotateX(53deg) rotate(${-angleRef.current}deg)`;
            ball.style.transform = `rotate(${-angleRef.current}deg)`;

            animationFrameRef.current = requestAnimationFrame(rotate);
        };

        animationFrameRef.current = requestAnimationFrame(rotate);

        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
        };
    }, [speed]);

    return (
        <div id="rouletteTable" className="w-100 h-100">
            <div id="rouletteWrapper">
                <div id="roulette">
                    <div id="roulette4" />
                    <div id="rouletteShadow" ref={rouletteShadowRef} />
                    <div id="rouletteShadow2" />
                    <div id="shine" />
                    <div id="rouletteShadow3" />
                    <div id="roulette2" ref={roulette2Ref} />
                    <div id="roulette6" />
                    <div id="roulette7" />
                    <div id="roulette5" ref={roulette5Ref}>
                        <div id="ballSpin" ref={ballSpinRef}>
                            <div id="ball" ref={ballRef} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default RouletteWheel;